// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTableMobileSort-ApplyButton_cls1__YUMPP","cls2":"VeloTableMobileSort-ApplyButton_cls2__tDRI- VeloTableMobileSort-ApplyButton_cls1__YUMPP"};